import { render, staticRenderFns } from "./falls-bar.vue?vue&type=template&id=6912f267&"
import script from "./falls-bar.vue?vue&type=script&lang=js&"
export * from "./falls-bar.vue?vue&type=script&lang=js&"
import style0 from "./falls-bar.vue?vue&type=style&index=0&id=6912f267&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports